import {FieldDescriptor} from "../../common/FormField";
import * as Yup from "yup";
import { validationSchemaVersOre2} from "./Services";
import {useGetDropAttivitaByIdProg, useGetDropNodiByIdProg, useGetDropProgettiByCodDip} from "../../common/Services";
import {Luoghi2List, Minord2List, Opzioni2List,tipoNodoToOpzione} from "./types";
import {UseFormSetValue} from "react-hook-form";



export  type VersOre2Form = Yup.InferType<typeof validationSchemaVersOre2>

export const useFieldsVersOre2_1 = (editOpzione: boolean, isBlocked: boolean): FieldDescriptor<VersOre2Form>[] => ([
  // { name: "id", label: "Id", type: "number", boxSize: "10%" },
  { name: "datareg", label: "Data", type: "date", boxSize: "33%", disabled: isBlocked, },
  { name: "datains", label: "Data Ins.", type: "date", boxSize: "33%", disabled: true },

   {
      name: "opzione",
      label: "Opzione",
      type: "autocomplete",
      boxSize: "33%",
      options:  Opzioni2List ,
      optionLabelKey: "label",
      optionValueKey: "value",
      disabled: !editOpzione || isBlocked,


    },


]);

export const useFieldsVersOre2_2 = (idprog: string, setValue: UseFormSetValue<VersOre2Form>,setIndclibloc: (v: number) => void,isBlocked: boolean): FieldDescriptor<VersOre2Form>[] => {
    const {data: DropProgettiApiResponse} = useGetDropProgettiByCodDip();
    const {data: DropNodiApiResponse} = useGetDropNodiByIdProg(idprog);
    const {data: DropAttivitaApiResponse} = useGetDropAttivitaByIdProg(idprog);


    return [
        {
            name: "idprog",
            label: "Progetto",
            type: "autocomplete",
            boxSize: "100%",
            options: () => DropProgettiApiResponse?.results ?? [],
            optionLabelKey: "desprogblocco",
            optionValueKey: "idprog",
            disabled: false,
            onChange: (_: any, idprog: string) => {
                    setValue("idnodo", "");
                    setValue("idatt", "");
                     const progetto = DropProgettiApiResponse?.results?.find(
                                        (p: any) => p.idprog === idprog
                                        );

                     const ind = progetto?.indclibloc ?? 0;

                      // 🔥 update parent state
                     setIndclibloc(ind);

            },

        },

        {
            name: "idnodo",
            label: "Nodo",
            type: "autocomplete",
            boxSize: "100%",
            options: () => DropNodiApiResponse?.results ?? [],
            optionLabelKey: "desnodo",
            optionValueKey: "idnodo",
            disabled: isBlocked || !idprog,
            onChange: (_: any, idnodo: string) => {
                     const nodo = DropNodiApiResponse?.results?.find(
                          (n: any) => n.idnodo === idnodo
                        );
                        const tiponodo = nodo?.tiponodo ?? "";
                        const opzione = tipoNodoToOpzione[tiponodo] ?? "";
                        setValue("opzione", opzione, { shouldValidate: true });
                        setValue("idatt", "");
                      }
        },
        {
            name: "idatt",
            label: "Attivita",
            type: "autocomplete",
            boxSize: "100%",
            options: () => DropAttivitaApiResponse?.results ?? [],
            optionLabelKey: "desatt",
            optionValueKey: "idatt",
            disabled: isBlocked || !idprog

        },
    ];
};


export const useFieldsVersOre2_3 = (isBlocked: boolean): FieldDescriptor<VersOre2Form>[] => ([
      { name: "orestraord", label: "Ore Eff.", type: "number", boxSize: "33%",disabled: isBlocked  },

      {
      name: "minstraord",
      label: "Min Eff.",
      type: "autocomplete",
      boxSize: "33%",
      options:  Minord2List ,
      optionLabelKey: "label",
      optionValueKey: "value",
      disabled: isBlocked,
    },
    { name: "oreord", label: "Ore", type: "number", boxSize: "33%", disabled: true },



]);


export const useFieldsVersOre2_4 = (isBlocked: boolean): FieldDescriptor<VersOre2Form>[] => ([
  { name: "note", label: "Note", type: "textarea", boxSize: "100%", rows: 4, multiline: true, inputProps: { maxLength: 255 }, disabled: isBlocked },
]);

export const useFieldsVersOre2_5 = (isBlocked: boolean): FieldDescriptor<VersOre2Form>[] => ([

     {
      name: "luogo",
      label: "Luogo",
      type: "autocomplete",
      boxSize: "50%",
      options:  Luoghi2List ,
      optionLabelKey: "label",
      optionValueKey: "value",
      disabled: isBlocked,
    },


    { name: "km", label: "Km", type: "number", boxSize: "25%", disabled: isBlocked  },
  { name: "trasf", label: "Trasferta", type: "number", boxSize: "25%",disabled: isBlocked },
]);

